"use client";
import { useEffect, useState } from "react";
import { useLookupStore } from "../stores/lookupStore";
import { useOnboardingStore } from "../stores/onboardingStore";
import { clearJourney, hydrateJourney } from "../stores/journey";

export function useJourneySession(restart = false) {
	const lookupReady = useLookupStore(state => state.hasHydrated);
	const onboardingReady = useOnboardingStore(state => state.hasHydrated);
	const [handledRestart, setHandledRestart] = useState<boolean | null>(null);
	useEffect(() => {
		let active = true;
		void hydrateJourney().then(() => {
			if (!active) return;
			const url = new URL(window.location.href);
			if (url.searchParams.get("restart") === "1") {
				clearJourney();
				url.searchParams.delete("restart");
				window.history.replaceState(
					window.history.state,
					"",
					`${url.pathname}${url.search}${url.hash}`,
				);
			}
			setHandledRestart(restart);
		});
		return () => {
			active = false;
		};
	}, [restart]);
	return lookupReady && onboardingReady && handledRestart === restart;
}
